<template>
  <div>
    <div class="subtitle-2">Corrosion</div>
    <CoveragePercentageRows :rows="filteredCorrosionRows" :metric-surface-area="props.metricSurfaceArea" />
    <div class="body-2">Substrate condition: {{ greatestAreaName(filteredCorrosionRows) }}</div>
    <div v-if="filteredDegreeOfRustingRows.length > 0">
      <div class="subtitle-2">Degree of Rusting</div>
      <CoveragePercentageRows :rows="filteredDegreeOfRustingRows" />
    </div>
  </div>
</template>

<script>
import { greatestArea } from '@/utils';
import { CoveragePercentageRows } from './components';

export default {
  name: 'CoverageLevels',
  components: {
    CoveragePercentageRows,
  },
  props: {
    props: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    filteredCorrosionRows() {
      const filterKeysRegex = new RegExp('^AC-[LMH]$');
      return this.props.coverageLayers.filter(({ key }) => filterKeysRegex.test(key));
    },
    filteredDegreeOfRustingRows() {
      const filterKeysRegex = new RegExp('^Ri[0-5]$');
      return this.props.coverageLayers.filter(({ key }) => filterKeysRegex.test(key));
    },
  },
  methods: {
    greatestAreaName(layers) {
      return greatestArea(layers).friendlyName;
    },
  },
};
</script>
